import configureEdit from './edit.vue'
import configureList from './list.vue'

let a = Object.assign({ configureEdit, configureList},)
export default a
